import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const TOKEN_KEY = "friedrich_token";

const http = axios.create({ baseURL: API, timeout: 90000 });

// Attach stored token to every request
http.interceptors.request.use(config => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers["Authorization"] = `Bearer ${token}`;
  return config;
});

// On 401, clear token and reload to show login page
http.interceptors.response.use(
  r => r,
  err => {
    if (err?.response?.status === 401) {
      localStorage.removeItem(TOKEN_KEY);
      window.location.reload();
    }
    return Promise.reject(err);
  }
);

export const api = {
  // Auth
  login: (email, password) => axios.post(`${BACKEND_URL}/api/auth/login`, { email, password }).then(r => r.data),
  register: (email, password, name, invite_code) => axios.post(`${BACKEND_URL}/api/auth/register`, { email, password, name, invite_code }).then(r => r.data),
  getMe: () => http.get("/auth/me").then(r => r.data),
  updateUserPreferences: (data) => http.patch("/auth/me/preferences", data).then(r => r.data),
  // Setups
  listSetups: () => http.get("/setups").then(r => r.data),
  getSetup: (id) => http.get(`/setups/${id}`).then(r => r.data),
  createSetup: (data) => http.post("/setups", data).then(r => r.data),
  updateSetup: (id, data) => http.patch(`/setups/${id}`, data).then(r => r.data),
  deleteSetup: (id) => http.delete(`/setups/${id}`).then(r => r.data),
  resetTriggers: (id) => http.post(`/setups/${id}/reset-triggers`).then(r => r.data),
  analyzeUrl: (url) => http.post("/setups/analyze-url", { url }).then(r => r.data),
  analyzeText: (text, source_url) => http.post("/setups/analyze-text", { text, source_url }).then(r => r.data),
  // Settings
  getSettings: () => http.get("/settings").then(r => r.data),
  saveSettings: (data) => http.put("/settings", data).then(r => r.data),
  testTelegram: () => http.post("/settings/test-telegram").then(r => r.data),
  testEmail: () => http.post("/settings/test-email").then(r => r.data),
  detectChatId: () => http.post("/settings/detect-chat-id").then(r => r.data),
  // Alerts
  listAlerts: () => http.get("/alerts").then(r => r.data),
  clearAlerts: () => http.delete("/alerts").then(r => r.data),
  // Polling
  pollNow: () => http.post("/poll/now").then(r => r.data),
  // Portfolio
  portfolioSummary: () => http.get("/portfolio/summary").then(r => r.data),
  // Quotes for top ticker
  getQuotes: () => http.get("/quotes").then(r => r.data),
  // Coach
  coach: (id) => http.post(`/coach/${id}`).then(r => r.data),
  coachChat: (id, messages) => http.post(`/coach/${id}/chat`, { messages }, { timeout: 120000 }).then(r => r.data),
  coachChatHistory: (id) => http.get(`/coach/${id}/chat/history`).then(r => r.data),
  coachChatClear: (id) => http.delete(`/coach/${id}/chat/history`).then(r => r.data),
  // Status table sync
  syncStatus: (text) => http.post("/setups/sync-status", { text, auto_apply: true }, { timeout: 120000 }).then(r => r.data),
  // Duplicate management
  findDuplicates: () => http.get("/setups-duplicates").then(r => r.data),
  deduplicateSetups: () => http.post("/setups-deduplicate").then(r => r.data),
  // Macro indicators
  getMacro: () => http.get("/macro").then(r => r.data),
  refreshMacro: () => http.post("/macro/refresh").then(r => r.data),
  // Admin
  adminStats: () => http.get("/admin/stats").then(r => r.data),
  adminListUsers: () => http.get("/admin/users").then(r => r.data),
  adminUpdateUser: (id, data) => http.patch(`/admin/users/${id}`, data).then(r => r.data),
  adminDeleteUser: (id) => http.delete(`/admin/users/${id}`).then(r => r.data),
  adminResetPassword: (id, password) => http.post(`/admin/users/${id}/reset-password`, { password }).then(r => r.data),
  adminCreateUser: (data) => http.post("/admin/users", data).then(r => r.data),
  changeOwnPassword: (password) => http.post("/auth/me/change-password", { password }).then(r => r.data),
};

export default api;
